export default "__VITE_ASSET__Cq28ajQ6__"